// produzioniThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setProduzioni,
  addProduzione,
  addProduzioneId,
  updateProduzione,
  deleteProduzione,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
} from "./produzioniSlice.js";
import produzioniAPI from "../../services/produzioniApi.js";
import { toast } from "react-toastify";

export const fetchProduzioni = createAsyncThunk(
  "produzioniData/fetchProduzioni",
  async (_, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await produzioniAPI.getAllProduzioni();
      dispatch(setProduzioni(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch produzioni.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const singleProduzione = createAsyncThunk(
  "produzioniData/fetchSingleProduzione",
  async (produzioneId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await produzioniAPI.getSingleProduzione(produzioneId);
      dispatch(addProduzioneId(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch single produzione.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const createProduzione = createAsyncThunk(
  "produzioniData/createProduzione",
  async (formData, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      console.log(formData);
      
      const response = await produzioniAPI.createProduzione(formData);
      dispatch(addProduzione(response.data.data));
      dispatch(addProduzioneId(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create produzione.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const updateProduzioneData = createAsyncThunk(
  "produzioniData/updateProduzione",
  async ({ id, data }, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await produzioniAPI.updateProduzione(id, data);
      dispatch(updateProduzione(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update produzione.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const deleteProduzioneData = createAsyncThunk(
  "produzioniData/deleteProduzione",
  async (id, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const res = await produzioniAPI.deleteProduzione(id);
      dispatch(deleteProduzione(id));
      dispatch(apiRequestSuccess());
      toast.success(res?.data?.message);
      return id;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete produzione.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
